import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { Table } from "../../../../../shared/Table/Table";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { Input } from "../../../../../shared/Input/Input";
import { InputLabel } from "../../../../../shared/InputLabel/InputLabel";
import { Button } from "../../../../../shared/Button/Button";
import styles from "../scss/LeadArIntegration.module.scss";
import { CircularProgress } from "../../../../../shared/CircularProgress/CircularProgress";
import { uiNotification } from "../../../../../services/UINotificationService";

const LeadArIntegrationTable = ({
  saveLeadArConfig,
  isMutating,
  locationId,
}) => {
  const { tSettings } = useAppTranslation.Settings();
  const { values, setFieldValue, errors, handleSubmit } = useFormik({
    initialValues: {
      locationId: locationId || "",
    },
    validationSchema: yup.object({
      locationId: yup.string().required(),
    }),
    onSubmit: (values) => {
      saveLeadArConfig(
        {
          isEnabled: true,
          locationId: values.locationId,
        },
        {
          onSuccess: () =>
            uiNotification.success("Location ID Saved Successfully!"),
        },
      );
    },
  });

  const tableData = [
    {
      locationId: (
        <div className={styles.locationInputContainer}>
          <InputLabel>Location ID</InputLabel>
          <Input
            size="small"
            className={styles.locationInput}
            value={values.locationId}
            onChange={(e) => setFieldValue("locationId", e.target.value)}
            isError={Boolean(errors.locationId)}
          />
        </div>
      ),
      actions: (
        <>
          <Button
            size="small"
            onClick={handleSubmit}
            isDisabled={isMutating}
            leftAdornment={
              isMutating ? (
                <CircularProgress size="small" color="white" />
              ) : null
            }
          >
            Save
          </Button>
        </>
      ),
    },
  ];
  return (
    <Table
      headColClassName={styles.tableHeader}
      data={tableData}
      cols={[
        {
          data: tSettings("leadArIntegration.table.locationId"),
          accessor: "locationId",
        },
        {
          data: tSettings("leadArIntegration.table.actions"),
          accessor: "actions",
        },
      ]}
    />
  );
};

export default LeadArIntegrationTable;
